import { AxiosError } from 'axios';
import {  GET_USER_CITIZEN_SHIPS } from '../../constants/apiUrls';
import {  GET_USER_CITIZEN_SHIPS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface UserCitizenShipsResponse {
    code: string;
    description: string
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: UserCitizenShipsResponse[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUserCitizenShips = ({ onSuccess, onError }: Input = {}) => {
  const getUserCitizenShips = async () => {
    const res = await axiosClient.get<UserCitizenShipsResponse[]>(
        GET_USER_CITIZEN_SHIPS
    );

    return res.data;
  };

  return useCustomQuery(
    [GET_USER_CITIZEN_SHIPS_QUERY_KEY], 
    getUserCitizenShips, 
    {
      onSuccess,
      onError,
    }
  );
};
